import { PaymentPlan } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'

/**
 * Returns payment plans from TierUsageStore.
 * The data is fetched once when the app loads via TieredUsageListener.
 */
export const usePaymentPlans = () => {
  const tierUsageStore = useRootStore().tierUsageStore

  return {
    data: { payment_plans: tierUsageStore.paymentPlans } as { payment_plans: PaymentPlan[] },
    isLoading: tierUsageStore.loading,
    isInitialized: tierUsageStore.initialized,
  }
}
